import { render, staticRenderFns } from "./HostSpecsListForm.vue?vue&type=template&id=adb71b2a"
import script from "./HostSpecsListForm.vue?vue&type=script&lang=js"
export * from "./HostSpecsListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports